export class ResourceUtils {
  static TYPES = {
    device: 'device',
    app: 'app',
    manager: 'manager',
  };

  static getOwnerUriFromId(resource) {
    if (typeof resource?.id !== 'string') {
      return null;
    }

    return resource.id.split(':').slice(0, 3).join(':');
  }

  static getOwnerUri(resource) {
    return ResourceUtils.getOwnerUriFromId(resource) ?? resource?.ownerUri ?? resource?.uri ?? null;
  }

  static isZoneUri(ownerUri) {
    return ownerUri?.startsWith('homey:zone:') ?? false;
  }

  static isMoodUri(ownerUri) {
    return ownerUri?.startsWith('homey:mood:') ?? false;
  }

  static isDeviceUri(ownerUri) {
    return ownerUri?.startsWith('homey:device:') ?? false;
  }

  static isAppUri(ownerUri) {
    return ownerUri?.startsWith('homey:app:') ?? false;
  }

  static isManagerUri(ownerUri) {
    return ownerUri?.startsWith('homey:manager:') ?? false;
  }

  static splitKey(key) {
    const split = key.split('::');

    if (split.length === 1) {
      return [null, split[0]];
    }

    return split;
  }

  static getOwnerId(resource) {
    return ResourceUtils.getOwnerTypeAndIdFromOwnerUri(ResourceUtils.getOwnerUri(resource)).id;
  }

  static getOwnerType(resource) {
    return ResourceUtils.getOwnerTypeAndIdFromOwnerUri(ResourceUtils.getOwnerUri(resource)).type;
  }

  static getOwnerName(resource) {
    return resource?.ownerName ?? resource?.uriObj?.name ?? null;
  }

  static getOwnerTypeAndIdFromOwnerUri(ownerUri) {
    if (ownerUri == null) {
      return {
        type: null,
        id: null,
      };
    }

    // homey:app:com.athom.homey:whatever
    const regex = /^homey:(?<type>app|manager|device|zone|logic|mood|user):(?<id>[^:]+)$/;
    const match = ownerUri.match(regex);

    // type = app
    // id = com.athom.homey

    if (match == null) {
      return {
        type: null,
        id: null,
      };
    }

    return { id: match.groups.id, type: match.groups.type };
  }

  static getOwnerProps(resource) {
    if (resource == null) {
      return {
        ownerUri: null,
        ownerId: null,
        ownerType: null,
      };
    }

    const ownerUri = ResourceUtils.getOwnerUri(resource);
    const { id, type } = ResourceUtils.getOwnerTypeAndIdFromOwnerUri(ownerUri);

    return {
      ownerUri,
      ownerId: id,
      ownerType: type,
    };
  }
}
